import type {
  HTMLProps,
  ReactNode,
  RefObject,
} from 'react';
import styled from 'styled-components';

import type {
  TooltipRenderProps,
} from '../Tooltip';

export const StyledSVG = styled.svg<{
  isOpen: boolean;
}>(({
  isOpen,

  theme: {
    colors,
  },
}) => ({
  verticalAlign: 'middle',
  fill: isOpen ? colors.NEUTRAL_SECONDARY : colors.NEUTRAL_INPUT,
}));

export type RenderReferenceParams = TooltipRenderProps & {
  className?: string;
};

export const renderReference = ({
  isOpen,
  innerProps,
  ref,
  className,
}: RenderReferenceParams): ReactNode => (
  <StyledSVG
    className={className}
    isOpen={isOpen}
    width={16}
    height={16}
    viewBox="0 0 16 16"
    {...innerProps as unknown as Omit<HTMLProps<SVGSVGElement>, 'ref' | 'as' | 'crossOrigin'>}
    ref={ref as unknown as RefObject<SVGSVGElement>}
  >

    <path d="M8.5 11V7H6.5V8H7.5V11H6V12H10V11H8.5Z" fill="currentColor" />
    <path d="M8 4C7.85167 4 7.70666 4.04398 7.58333 4.12639C7.45999 4.2088 7.36386 4.32594 7.30709 4.46298C7.25033 4.60003 7.23548 4.75083 7.26441 4.89631C7.29335 5.0418 7.36478 5.17544 7.46967 5.28033C7.57456 5.38522 7.7082 5.45665 7.85369 5.48558C7.99917 5.51452 8.14997 5.49967 8.28701 5.44291C8.42406 5.38614 8.54119 5.29001 8.6236 5.16667C8.70602 5.04334 8.75 4.89833 8.75 4.75C8.75 4.55108 8.67098 4.36032 8.53033 4.21967C8.38968 4.07901 8.19892 4 8 4Z" fill="currentColor" />
    <path d="M8 15C6.61553 15 5.26216 14.5895 4.11101 13.8203C2.95987 13.0511 2.06266 11.9579 1.53285 10.6788C1.00303 9.3997 0.86441 7.99223 1.13451 6.63436C1.4046 5.2765 2.07129 4.02922 3.05026 3.05025C4.02922 2.07128 5.2765 1.4046 6.63437 1.1345C7.99224 0.864402 9.3997 1.00303 10.6788 1.53284C11.9579 2.06265 13.0511 2.95986 13.8203 4.111C14.5895 5.26215 15 6.61553 15 8C15 9.85651 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15ZM8 2C6.81332 2 5.65328 2.35189 4.66658 3.01118C3.67989 3.67047 2.91085 4.60754 2.45673 5.7039C2.0026 6.80025 1.88378 8.00665 2.11529 9.17054C2.3468 10.3344 2.91825 11.4035 3.75736 12.2426C4.59648 13.0818 5.66558 13.6532 6.82946 13.8847C7.99335 14.1162 9.19975 13.9974 10.2961 13.5433C11.3925 13.0891 12.3295 12.3201 12.9888 11.3334C13.6481 10.3467 14 9.18668 14 8C14 6.4087 13.3679 4.88257 12.2426 3.75735C11.1174 2.63214 9.5913 2 8 2Z" fill="currentColor" />

  </StyledSVG>
);
